import React, { useEffect } from 'react';

import styled from 'styled-components';

import { FILLOUT } from 'constants/UrlConstants';

import { removeScript } from 'helpers/DOM';

import fonts from 'theme/fonts';
import promoMedia from 'theme/promoMedia';

const BtnContainer = styled.div`
    button {
        font-family: ${fonts.regular} !important;
        font-weight: normal !important;
        font-size: 14px !important;
        line-height: 19px !important;
        padding: 0 24px !important;
        height: 40px;

        ${promoMedia.desktop1440} {
            font-size: 16px !important;
            line-height: 21px !important;
            height: 48px;
        }
    }
`;

const NavBtnContainer = styled.div`
    button {
        font-family: ${fonts.regular} !important;
        font-weight: normal !important;
        font-size: 16px !important;
        line-height: 21px !important;
        padding: 16px !important;
        box-shadow: 8px 8px 16px 2px rgba(228, 214, 255, 0.6) !important;
        width: 100%;

        ${promoMedia.desktop1440} {
            padding: 14px 24px !important;
        }
    }
`;

const getComponent = (props) => {
    if (props.isNavButton) {
        return NavBtnContainer;
    } else return BtnContainer;
};

const GetStartedButton = (props) => {
    useEffect(() => {
        if (__isBrowser__) {
            const script = document.createElement('script');
            script.src = FILLOUT;
            script.defer = true;
            document.body.appendChild(script);
        }
        return () => removeScript(FILLOUT);
    }, []);

    const Container = getComponent(props);

    return (
        <Container isNavButton={props.isNavButton}>
            <div
                data-fillout-id="5ZKN62yiNZus"
                data-fillout-embed-type="popup"
                data-fillout-button-text={props.buttonText}
                data-fillout-dynamic-resize
                data-fillout-button-color="#7733FF"
                data-fillout-inherit-parameters
                data-fillout-popup-size="medium"
            />
        </Container>
    );
};

export default GetStartedButton;
